/* ==========================================================================
   MILFSHAKES · "VISTOS RECIENTEMENTE" EN EL CAJÓN DE BÚSQUEDA
   --------------------------------------------------------------------------
   Lee los ids que el propio tema ya guarda al visitar fichas de producto
   (localStorage "theme:recently-viewed-products") y pide sus tarjetas a la
   vista templates/search.recently-viewed.liquid, que devuelve solo las tarjetas
   (~20 KB) en vez de una página entera.

   NO se reutiliza el <recently-viewed-products> del tema a propósito: cuando
   no encuentra productos hace section.remove(), y aquí la sección contenedora
   es el cajón de búsqueda entero — a un visitante nuevo le desaparecería el
   buscador. Este componente solo se elimina A SÍ MISMO.
   ========================================================================== */
(function () {
  if (customElements.get('search-recently-viewed')) return;

  var STORAGE_KEY = 'theme:recently-viewed-products';

  class SearchRecentlyViewed extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;
      this.loaded = true;

      var ids = [];
      try {
        ids = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      } catch (e) {
        ids = [];
      }

      if (!Array.isArray(ids) || ids.length === 0) { this.remove(); return; }

      var target = this.querySelector('[data-recently-viewed-target]');
      if (!target) { this.remove(); return; }

      var count = parseInt(this.getAttribute('products-count') || '12', 10);
      var query = ids.slice(0, count).map(function (id) { return 'id:' + id; }).join(' OR ');
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url = root + 'search?type=product&view=recently-viewed&q=' + encodeURIComponent(query);

      fetch(url, { priority: 'low' })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cards = doc.body ? Array.prototype.slice.call(doc.body.children) : [];
          if (!cards.length) { this.remove(); return; }

          cards.forEach(function (card) {
            // El tema pinta con opacity:0 lo que lleva reveal-on-scroll y lo revela
            // con un observador que no ve los nodos insertados después.
            card.removeAttribute('reveal-on-scroll');
            card.querySelectorAll('[reveal-on-scroll]').forEach(function (el) {
              el.removeAttribute('reveal-on-scroll');
            });
            target.appendChild(card);
          });

          this.hidden = false;
        }.bind(this))
        .catch(function () { this.remove(); }.bind(this));
    }
  }

  customElements.define('search-recently-viewed', SearchRecentlyViewed);
})();
